import {ApplicationAttributeType} from '@marketplace/api';

export const getParsedApplicationAttributes = (arr: ApplicationAttributeType[]):string => {
  let name = '';
  const arrayNames = arr?.map((item: ApplicationAttributeType) => [item.name]);
  name = arrayNames?.join(', ');
  
  return name;
};